module.exports = __webpack_public_path__ + "media/images/emblems/Cheseaux-sur-Lausanne-coat_of_arms-afcf5a537d72e6489201e3a6c49f7df3.svg";